import React, { Component } from 'react';
import Modal from 'react-responsive-modal';

import NavBar from '../../components/navigation/NavBar';
import RateView from '../../components/rateview/RateView';

import { getCurrentResource } from '../../util/tools';
import { canPerformAction } from '../../util/localStorage';
import { ACTION_MREPORT_IMPORT } from '../../util/consts/actions';
import { FORM_MREPORT_TABLE } from '../../util/consts/forms';
import { 
	performApiRequestForm, performApiRequest, 
	ACTION_MREPORT_IMPORT_API_URL,
	ACTION_MREPORT_IMPORT_LOCAL_API_URL 
} from '../../util/restapi';

import iconImport from '../../assets/icons/png24x24/get_message.png';

const MODAL_MODE_ACTIVE = 'a';
const MODAL_MODE_WAIT = 'w';
const MODAL_MODE_COMPLETE = 'c';

const IMPORT_MODE_NETWORK = 'network';
const IMPORT_MODE_LOCAL = 'local';

class MReportListPage extends Component {
	
	constructor(props) {
		super(props);
		this.refImportModal = React.createRef();
		this.resource = getCurrentResource().pages.tableform.MReportList;
		let paramCacheId = props.match.params.param;
		this.state = {
			isImportModalOpen: false,
		}

		this.rvContext = {
			form: FORM_MREPORT_TABLE,
			data: []
		};
		this.rvOptions = {
			form: FORM_MREPORT_TABLE,
			formTitle: this.resource.formTitle,
			paramCacheId: paramCacheId,
			transition: null,
			//hideButtonAdd: true,
			//hideButtonEdit: true,
			hideButtonMergeInstances: true,
			//hideButtonChangeOwner: true,
			//hideButtonFieldUpdate: true,
			hideButtonGlobalIdUpdate: true,
			//hideButtonDelete: true,
			//hideButtonShowHtml: true,
			//hideButtonHtml: true,
			//hideButtonPdf: true,
			//hideButtonXml: true,
			//hideButtonTransition: true,
			//hideButtonUshExport: true,
			//hideButtonUshImport: true,
			hideButtonSendEmail: true,
			controlPanelTools: this.controlPanelTools(),
		};
	}
	componentDidMount() {
		document.title = 'BOM. ' + this.resource.formTitle;
	}
	controlPanelTools = () => {
		return (
			<div style={{textAlign: 'left', marginLeft: '20px'}}>
				<ControlPanelButtonImport holder={this} />
			</div>			
		);
	}
	openImportModal = () => {
		this.refImportModal.current.initModal();
		this.setState({ isImportModalOpen: true });	
	}
	closeImportModal = () => {
		this.setState({ isImportModalOpen: false });	
	}

	render() {
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<RateView rvContext={this.rvContext} rvOptions={this.rvOptions} app={this.props.app}  />
				<ImportModal ref={this.refImportModal} page={this} 
					isModalOpen={this.state.isImportModalOpen} 
					close={this.closeImportModal} 
				/>
			</React.Fragment>
		)
	}
	
}

class ImportModal extends React.Component {

	constructor(props) {
		super(props);
		this.resource = props.page.resource;
		this.fileImportRef = React.createRef();
		this.file = null;
		this.resultMessage = '';
		this.resultLog = '';
		this.state = {
			modalMode: MODAL_MODE_ACTIVE,
			importMode: IMPORT_MODE_NETWORK,
			fileName: this.resource.textSelectFile,
			filePath: '',
		}
	}
	initModal = () => {
		this.file = null;
		this.resultMessage = '';
		this.resultLog = '';
		this.setState({
			modalMode: MODAL_MODE_ACTIVE,
			importMode: IMPORT_MODE_NETWORK,
			fileName: this.resource.textSelectFile,
			//filePath: '',
		});
	}
	tryAgain = () => {
		this.setState({	modalMode: MODAL_MODE_ACTIVE});
	}

	onImportModeChange = (event) =>	{
		this.setState({ importMode: event.target.value });
	}
	onFilePathChange = (event) =>	{
		this.setState({ filePath: event.target.value });
	}
	handleFileSelect = (e) => {
		let files = e.target.files;
		if( files && files.length > 0 ) {
			this.file = files[0];
			this.setState({fileName: this.file.name})
		}
	}	

	startImport = async () => {
		this.setState({modalMode: MODAL_MODE_WAIT})

		let response;
		if( this.state.importMode == IMPORT_MODE_NETWORK ) {
			const form = new FormData();
			form.append('format', 'xml');
			form.append('file', this.file);
			response = await performApiRequestForm(ACTION_MREPORT_IMPORT_API_URL, form);
		} else if( this.state.importMode == IMPORT_MODE_LOCAL ) {
			let importOptions = {
				filePath: this.state.filePath
			}
			response = await performApiRequest( ACTION_MREPORT_IMPORT_LOCAL_API_URL, importOptions );
		} else {
			response = {success: false, message: 'Unknown import mode'};
		}
		
		if( response.success ) {
			this.resultMessage = response.message;
			this.resultLog = response.log;
			if( this.resultMessage == '' ) {
				this.resultMessage = this.resource.messageImportComplete;
			} 
		} else {
			this.resultMessage = response.message; 
			this.resultLog = response.log;
		}
		this.setState({modalMode: MODAL_MODE_COMPLETE})
	}

	render() {
		let resource = this.resource;
		let modalBodyHtml;
		let holder = this.props.page;
		if( this.state.modalMode == MODAL_MODE_COMPLETE ) {
			let divAdditionalMessage = null;
			if( this.resultLog ) {
				divAdditionalMessage = (
					<div style={{marginLeft: 'auto', marginRight: 'auto', marginBottom: '30px', width: '95%'}}>
						<textarea style={{width: '100%'}} rows="8" readOnly={true}>
							{this.resultLog}
						</textarea>
					</div>		
				);
			}
			modalBodyHtml = (
				<React.Fragment>
					<div style={{color: 'red', textAlign: 'center', padding: '30px', fontSize: '16pt'}} 
						dangerouslySetInnerHTML={{__html: this.resultMessage}}
					/>
					{divAdditionalMessage}
					<div style={localStyles.divButtons}>
						<button type='button' onClick={this.tryAgain} >
							{resource.buttonTryAgain}
						</button>
					</div>
				</React.Fragment>
			);
		} else {
			let divFileHtml = null 
			if( this.state.importMode == IMPORT_MODE_NETWORK ) {
				divFileHtml = (
					<div>
						{resource.labelFile}: 
						<span style={{marginLeft: '5px', marginRight: '10px'}}>{this.state.fileName}</span> 
						<button onClick={e => this.fileImportRef.current.click()}>...</button>
						<input ref={this.fileImportRef} type={'file'}  style={{display: 'none'}} 
							onChange={e => this.handleFileSelect(e)} 
						/>
					</div>
				);
			} else if( this.state.importMode == IMPORT_MODE_LOCAL ) {
				divFileHtml = (
					<div>
						{resource.labelFile}: <input type='text' size='40' value={this.state.filePath} onChange={this.onFilePathChange} /> 
					</div>
				);
			}
			let buttonImportDisabled = this.state.modalMode == MODAL_MODE_WAIT || 
				(this.file == null && this.state.importMode == IMPORT_MODE_NETWORK);
			let divWaiting = this.state.modalMode == MODAL_MODE_WAIT ?
				(<div style={localStyles.divWaiting}>{resource.waiting}</div>) : null;  
			modalBodyHtml = (
				<div style={{margin: '15px'}}>
					<div style={{marginTop: '15px', marginBottom: '15px'}}>
						<select value={this.state.importMode} onChange={this.onImportModeChange}>
							<option value={IMPORT_MODE_NETWORK}>{resource.optionNetworkImport}</option>
							<option value={IMPORT_MODE_LOCAL}>{resource.optionLocalImport}</option>
						</select>
					</div>
					{divFileHtml}
					{divWaiting}
					<div style={localStyles.divButtons}>
						<button type='button' title={resource.buttonImportTooltip}
							onClick={this.startImport} disabled={buttonImportDisabled}
						>
							{resource.buttonImport}
						</button>
					</div>
				</div>
			);
		}
		return (
			<Modal 
				open={this.props.isModalOpen} onClose={this.props.close} center 
				styles={styleModal} closeOnOverlayClick={false} animationDuration={1} 
			>
				<div>
					<div style={localStyles.divHeader}>
						{this.resource.modalImportTitle}
					</div>
					{modalBodyHtml}
				</div>
			</Modal>
		);
	}
}

function ControlPanelButtonImport(props) {
	
	if( canPerformAction( ACTION_MREPORT_IMPORT ) ) {
		return (
			<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
				 onClick={props.holder.openImportModal}
				 title={props.holder.resource.buttonImportTooltip} 
			>
				<img src={iconImport} />
			</button>			
		);
	} else {
		return null;
	}
}

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '500px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

const localStyles = {
	divHeader: {
		fontSize: '16pt',
		textAlign: 'center',
		padding: '10px',
		borderRadius: '21px 21px 0 0',
		backgroundColor: '#F0F0F0'
	},
	divParameters: {
		marginTop: '10px',
		padding: '10px'
	},
	divWaiting: {
		textAlign: 'center',
		padding: '7px'
	},
	divButtons: {
		marginTop: '7px',
		padding: '10px',
		marginRight: '15px',
		textAlign: 'right'
	}
};

export default MReportListPage;
